//libs
import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
//components
import Selectable from "./Forms/Form_Elements/Selectable";
import PopUp from "./Forms/PopUp";
import CreateUserForm from "./Forms/CreateUserForm";
//helpers
import {isAdmin} from '../../helpers';
//actions
import {destroy, restore, assimilate} from '../../actions/users';

class ListItemsUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            editUserId: null,
            deleteUserId: null,
            restoreUserId: null,
            active: props.user.active,
            user: props.user
        };
    }

    selectItem(e) {
        this.setState({
            ...this.state,
            selected: !this.state.selected
        });
    }

    becomeUser(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.assimilate(e.target.getAttribute("value"));
    }

    editUser(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            editUserId: e.target.getAttribute("value")
        });
    }

    editAccept(e) {
        this.setState({
            editUserId: null
        });
    }

    editCancel(e) {
        this.setState({
            editUserId: null
        });
    }

    deleteUser(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            deleteUserId: e.target.getAttribute("value")
        });
    }

    deleteAccept(e) {
        let userIdToDelete = this.state.deleteUserId;
        this.setState({
            deleteUserId: null,
            active: false
        });
        //api call for delete users...
        this.props.destroy(userIdToDelete);
    }

    deleteCancel(e) {
        this.setState({
            deleteUserId: null
        })
    }


    restoreAccept(e) {
        let userIdToRestore = this.state.restoreUserId;
        this.setState({
            restoreUserId:null,
            active: true
        });
        this.props.restore(userIdToRestore);
    }

    restoreCancel(e) {
        this.setState({
            restoreUserId: null
        })
    }

    restoreUser(e) {
        alert("todo :)");
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            restoreUserId: e.target.getAttribute("value")
        });
    }

    onUpdatedUser(updatedUserData) {

        this.setState({
            user: updatedUserData
        });

    }

    render() {

        const {id, firstname, lastname,role} = this.state.user;
        const {selected, deleteUserId, active, editUserId, restoreUserId} = this.state;
        let classes = ["user"];
        if (selected) {
            classes.push("selected");
        }
        if (!active) {
            classes.push("disabled");
        }
        if (this.props.updatingUser === id) {
            classes.push("updating");
        }

        if (this.props.className){
            classes.push(this.props.className);
        }

        return (
            <div className={classes.join(" ")} key={id}>
                <Selectable onClick={(e) => this.selectItem(e)} userRole={role} title={firstname + ' ' + lastname}/>
                <div className="userActionsWrapper">
                    {active && isAdmin() &&
                    <div className="userActions">
                        <ul>
                            <li value={id}>
                                <a className="icon incarnate"
                                   onClick={(e) => this.becomeUser(e)}
                                   value={id} href={"#assimilera"}>
                                    Assimilera
                                </a>
                            </li>
                            <li value={id}>
                                <a className="icon edit"
                                   onClick={(e) => this.editUser(e)}
                                   value={id} href={"#redigera"}>
                                    Redigera
                                </a>
                            </li>
                            <li value={id}>
                                <a className="icon delete"
                                   onClick={(e) => this.deleteUser(e)}
                                   value={id}
                                   href={"#delete"}>
                                    Ta bort
                                </a>
                            </li>
                        </ul>
                    </div>
                    }

                    {!active && isAdmin() &&
                    <div className="userActions">
                        <ul>
                            <li value={id}>
                                <a className="icon restore"
                                   onClick={(e) => this.restoreUser(e)}
                                   value={id} href={"#lysa-upp"}>
                                    Lysa upp
                                </a>
                            </li>
                        </ul>
                    </div>
                    }


                </div>

                {deleteUserId &&
                <PopUp
                    onAccept={(e) => this.deleteAccept(e)}
                    onCancel={(e) => this.deleteCancel(e)}
                    title={"Ta bort användaren \"" + firstname + " " + lastname + "\", är du säker?"}
                />
                }

                {restoreUserId &&
                <PopUp
                    onAccept={(e) => this.restoreAccept(e)}
                    onCancel={(e) => this.restoreCancel(e)}
                    title={"Återställ användaren \"" + firstname + " " + lastname + "\", är du säker?"}
                />
                }

                {editUserId &&
                <PopUp
                    onAccept={(e) => this.editSave(e)}
                    onCancel={(e) => this.editCancel(e)}
                    acceptButtonText={"Uppdatera"}
                    cancelButtonText={"Annullera"}
                    title={null}
                    showButtons={false}
                >
                    <CreateUserForm
                        title={"Redigera användare \"" + firstname + " " + lastname + "\""}
                        user={this.state.user}
                        onCancel={(e) => this.editCancel(e)}
                        onAccept={(e) => this.editAccept(e)}
                        onUpdatedUser={(updatedUserData) => this.onUpdatedUser(updatedUserData)}
                    />
                </PopUp>
                }

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        updatingUser: state.users.updatingUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        destroy: (id) => dispatch(destroy(id)),
        restore: (id) => dispatch(restore(id)),
        assimilate: (id) => dispatch(assimilate(id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListItemsUser)



// WEBPACK FOOTER //
// ./src/components/UI_Elements/ListItemsUser.js